SideBar = function () {
    var openSideBar = function openSideBar(e) {
        e.preventDefault();
        $('#sidebar').slideToggle();
        $(this).blur();
        $('body').toggleClass('sidebar');
        $('.nav-toggle').toggleClass('sidebar-expanded');

        if ($('.nav-toggle > span').html() === "Meny") {
            $('.nav-toggle > span').html("Stäng meny");
        } else {
            $('.nav-toggle > span').html("Meny");
        }
    };

    var closeSideBar = function closeSideBar(e) {
        e.preventDefault();
        $('body').removeClass('sidebar');
        $('#sidebar').hide();
        $('.nav-toggle').removeClass('sidebar-expanded'); ////When sidebar animation complete, hide the sidebar.
        //$("#wrap").on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', function (e) {
        //    if ($(e.target).is('#wrap')) {
        //        if (!$('body').hasClass('sidebar')) {
        //            $('#sidebar').hide();
        //        }
        //    }
        //});
        //Remove querystring

        if (history.pushState) {
            var cleanuri = location.protocol + "//" + location.host + location.pathname;
            window.history.replaceState({}, document.title, cleanuri);
        }
    };

    var registerEvents = function registerEvents() {
        $('.nav-toggle').click(openSideBar);
        $('.search-toggle').click(function () {
            $('#headersearch').fadeToggle();
            $('.header-area').toggleClass('open');
            $('#sidebar').toggleClass('open');
        });
        $('.nav-toggle').click(function () {
            $('#nav-icon4').toggleClass('open');
        });
        $('#sidebar ul a').click(function (e) {
            e.preventDefault();
            var parser = document.createElement('a');
            parser.href = $(this).attr('href');
            var uri = parser.pathname;

            if (uri.charAt(0) != "/") {
                uri = "/" + uri;
            }

            window.location.href = uri + '?nav=true';
        }); //$('.sidebar-overlay').swipe({
        //    tap: closeSideBar,
        //    swipeLeft: closeSideBar,
        //    threshold: 75,
        //    excludedElements: []
        //});

        $('#sidebar a').blur(function (e) {
            setTimeout(function () {
                if ($(document.activeElement).closest('#sidebar').length == 0) {
                    closeSideBar(e);
                }
            }, 1);
        });
    };

    var iScrollPos = 0;

    var scrollSideBar = function scrollSideBar(e) {
        e.preventDefault();
        var iCurScrollPos = $(this).scrollTop();

        if (iCurScrollPos > iScrollPos) {
            console.log("scrolling dowm");
            $('#sidebar').slideUp();
            $('.nav-toggle').removeClass('sidebar-expanded'); //$('.header-area').css('height', "80px");
        } else {
            $('#sidebar').slideDown();
            $('.nav-toggle').addClass('sidebar-expanded'); //Scrolling Up
            //$('.header-area').css('height', "95px");

            console.log("scrolling up");
        }

        iScrollPos = iCurScrollPos;
    };

    var init = function init() {
        $(document).ready(function () {
            $('#sidebar').removeClass('sidebar-init');
        });

        if (!$('body').hasClass('sidebar')) {
            $('#sidebar').hide();
        }

        registerEvents();
    };

    return {
        init: init,
        open: openSideBar
    };
}();